<a [routerLink]="inboxPath">
  <div
    class="inbox-item hover-select-item-background display-on-hover-zone"
    [ngClass]="[themeClass, isSelected ? 'highlighted' : '']"
  >
    <div class="title">
      <span *ngIf="title"> {{ title }} </span>
      <span *ngIf="!title && !error"> New thread. </span>
      <span *ngIf="error"> {{ error }} </span>
    </div>

    <div class="top-right">
      <button
        *ngIf="!inArchive"
        mat-icon-button
        class="inbox-item-button display-on-hover display-on-mobile-muted"
        (click)="archive()"
        matTooltip="Archive"
        aria-label="Archive"
      >
        <mat-icon class="material-icons-outlined">archive</mat-icon>
      </button>

      <button
        *ngIf="inArchive"
        mat-icon-button
        class="inbox-item-button display-on-hover display-on-mobile-muted"
        (click)="unarchive()"
        matTooltip="Send to inbox"
        aria-label="Send to inbox"
      >
        <mat-icon class="material-icons-outlined">forward_to_inbox</mat-icon>
      </button>
    </div>

    <div class="latest-message">
      <div class="message-text">
        <ng-container *ngIf="latestMessage">
          <span *ngIf="latestMessage.userId === authUser._id" class="user-bold">
            You:
          </span>
          <span
            *ngIf="latestMessageSender && latestMessage.userId !== authUser._id"
            class="user-bold"
          >
            {{ latestMessageSender.name }}:
          </span>
          <mat-icon *ngIf="latestMessage.files"> description </mat-icon>
          {{ latestMessage.body }}
        </ng-container>
      </div>
    </div>

    <div class="bottom-right">
      <div class="unread-count-outer">
        <div *ngIf="unreadMessageCount" class="unread-count">
          {{ unreadMessageCount }}
        </div>
      </div>

      <div class="time light-text-color">{{ displayTime }}</div>
    </div>
  </div>
</a>
